import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { SCHOOL_QUIZ_API_BASE_URL } from "../../../src/configs/WebService";
import {
  setState,
  setUpdateQuizForm,
  updateWinnerPrizeNew,
} from "./redux/slice";
import {
  updateQuiz,
  fetchThemes,
  fetchSubjects,
  fetchSubjectBasedClassesData,
  fetchQuizTypes,
  getQuizzes,
} from "./redux/thunk";
import ThemeSelector from "./ThemeSelector";
import { convertTermsToHtml } from "./utils";
import "./css/create-quiz.css";

const LevelTableCommon = ({ data = [], type }) => {
  const isAcademic = type === 1 || type === 2;
  const isThematic = type === 3 || type === 4;
  const rows = data;
  return (
    <table className="cq-table">
      <thead>
        <tr>
          {isAcademic && (
            <>
              <th>Class</th>
              <th>Subject</th>
            </>
          )}

          {isThematic && (
            <>
              <th>Parent theme</th>
              <th>Child theme</th>
              <th>Group</th>
            </>
          )}

          <th className="num">Total</th>
          <th className="num">Basic</th>
          <th className="num">Advanced</th>
          <th className="num">Ultra</th>
          <th className="num">Docmaster</th>
        </tr>
      </thead>

      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={isAcademic ? 7 : 8} style={{ textAlign: "center" }}>
              No data available
            </td>
          </tr>
        ) : (
          rows.map((item, index) => {
            const total = Number(item.total ?? 0);
            return (
              <tr key={index} className={total === 0 ? "is-zero" : undefined}>
                {isAcademic && (
                  <>
                    <td>{item.class_name || "-"}</td>
                    <td>{item.subject_name || "-"}</td>
                  </>
                )}

                {isThematic && (
                  <>
                    <td>{item.parent_theme || "-"}</td>
                    <td>{item.child_theme || "-"}</td>
                    <td>{item.group_name || "-"}</td>
                  </>
                )}

                <td className="num">{total}</td>
                <td className="num">{item.basic ?? 0}</td>
                <td className="num">{item.advanced ?? 0}</td>
                <td className="num">{item.ultra ?? 0}</td>
                <td className="num">{item.docmaster ?? 0}</td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export default function EditQuiz({ allotments, quizType }) {
  const { selectedQuiz, updateQuizForm, selectedSubThemes } = useSelector(
    (state) => state.quizManagement,
  );
  const user = useSelector((state) => state.authSlice.user);

  const { themes, quizTypesList, subjectsList, subjectBasedClasses } =
    useSelector((state) => state.schoolQuiz || {});

  const classes = subjectBasedClasses?.data || [];
  const subjects = subjectsList?.data || [];

  const [groups, setGroups] = useState([]);
  const [error, setError] = useState("");
  const fetchGroups = async () => {
    setError("");
    try {
      const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
      setGroups(Array.isArray(res.data) ? res.data : res.data?.data || []);
    } catch (err) {
      setError("Failed to fetch groups");
      console.error("fetchGroups error:", err);
    }
  };
  const dispatch = useDispatch();
  const {
    id,
    title,
    // start,
    registrationStart,
    registrationEnd,
    totalQuestions,
    questionDuration,
    correct,
    start,
    wrong,
    skipped,
    enableWrongMarks,
    enableSkippedMarks,
    registrationFeeMode,
    registrationCost,
    prizeDescription,
    about_quiz,
    quiz_terms,
    updated_by,
    // law_selected,
    description,
    // quizType,
    class_id,
    subject_id,
    subjectSpecificClasses,
  } = updateQuizForm;
  const data = selectedQuiz;
  const [group_id, setGroupId] = useState("");
  const [state, setStatee] = useState({
    allotments: allotments || [],
  });
  const [countInfo, setCountInfo] = useState(null);
  const userId = JSON.parse(localStorage.getItem("user"))?.id;

  useEffect(() => {
    dispatch(fetchSubjects());
    dispatch(fetchThemes());
    dispatch(fetchQuizTypes());

    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  // console.log()
  // useEffect(() => {
  //   if (updateQuizForm.subject_id) {
  //     // ensure numeric id if your thunk expects it
  //     dispatch(fetchSubjectBasedClassesData(Number(updateQuizForm.subject_id)));
  //   }
  // }, [updateQuizForm.class_id, dispatch]);

  useEffect(() => {
    if (!updateQuizForm.subject_id) return;

    dispatch(
      fetchSubjectBasedClassesData({
        subject_id: Number(updateQuizForm.subject_id),
      }),
    )
      .unwrap()
      .then((res) => {
        console.log("subjectBasedClasses:", res); // check shape once, then remove
        dispatch(
          setUpdateQuizForm({
            key: "subjectSpecificClasses",
            value: res, // store whatever the thunk actually resolves to
          }),
        );
        dispatch(setUpdateQuizForm({ key: "group_idd", value: [] }));
      })
      .catch(
        (err) => console.error("fetchSubjectBasedClassesData failed:", err),
        dispatch(
          setUpdateQuizForm({
            key: "subjectSpecificClasses",
            value: [], // store whatever the thunk actually resolves to
          }),
        ),
      );
  }, [updateQuizForm.subject_id, dispatch]);
  const formatToISTDatetimeLocal = (utcDateStr) => {
    if (!utcDateStr) return "";
    const date = new Date(utcDateStr);
    const istString = date.toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Format returned like: "10/07/2025, 16:45"
    const [datePart, timePart] = istString.split(", ");
    const [day, month, year] = datePart.split("/");
    return `${year}-${month}-${day}T${timePart}`;
  };
  console.log("selected quiz", selectedQuiz);
  // 🟢 Replace your old "if (data)" useEffect with this version:
  useEffect(() => {
    // Wait until both data and classes have loaded
    if (data && classes.length > 0) {
      dispatch(
        setUpdateQuizForm({
          id: data.id || "",
          title: data.title || "jiii" || "",
          start: formatToISTDatetimeLocal(data.start_date),
          registrationStart: formatToISTDatetimeLocal(
            data.registration_start_date,
          ),
          registrationEnd: formatToISTDatetimeLocal(data.registration_end_date),
          totalQuestions: data.total_questions || "",
          questionDuration: data.duration_per_question || "",
          enableSkippedMarks: !!data.negative_marks_skipped,
          enableWrongMarks: !!data.negative_marks_wrong,
          correct: data.marks_per_question || "",
          registrationCost: data.registration_fee,
          registrationFeeMode: data.registration_fee > 0.0 ? "paid" : "free",
          wrong: data.negative_marks_wrong || "",
          skipped: data.negative_marks_skipped || "",
          winnerPrizes: Object.values(data.prizes || {}),
          topWinnersCount: Object.keys(data.prizes || {}).length,
          about_quiz: data.about_quiz,
          quiz_terms: data.quiz_terms,
          updated_by: userId,
          prizeDescription: data.prizes,
          description: data.description,
          class_id: String(data.class_id || ""),
          className: data.className || "",
          subject_id: String(data.subject_id || ""),
          themeData: data.themeDetails,
        }),
      );

      setGroupId(data?.group_id);
      setStatee((prev) => ({
        ...prev,
        allotments: data.difficulty_allotment,
      }));
    }
    // }, [data, classes.length, dispatch]);
  }, [data, dispatch]);

  function formatTerms(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }
  const handleChange = (key, value) => {
    dispatch(setUpdateQuizForm({ key, value }));

    // }
  };

  const handlePrizeChange = (index, value) => {
    dispatch(updateWinnerPrizeNew({ index, value }));
  };

  function handleAllotmentChange(difficulty_level) {
    if (
      !state.allotments.some(
        (item) => item.difficulty_level === difficulty_level,
      )
    ) {
      setStatee((prev) => ({
        ...prev,
        allotments: [...prev.allotments, { difficulty_level, percentage: "" }],
      }));
    }
  }

  const removeAllotment = (difficulty_level) => {
    setStatee((prev) => ({
      ...prev,
      allotments: prev.allotments.filter(
        (a) => a.difficulty_level !== difficulty_level,
      ),
    }));
  };
  function updatePercent(index, value) {
    setStatee((prev) => {
      const updated = prev.allotments.map((item, i) =>
        i === index ? { ...item, percentage: value } : item,
      );
      return { ...prev, allotments: updated };
    });
  }

  const handleSubmit = async () => {
    // =========================================================
    // QUIZ TYPE FLAGS
    // =========================================================
    const isLiveQuiz = quizType === 1 || quizType === 3;
    const isPracticeQuiz = quizType === 2 || quizType === 4;

    const isAcademicQuiz = quizType === 1 || quizType === 2;
    const isThematicQuiz = quizType === 3 || quizType === 4;

    // =========================================================
    // COMMON VALIDATION
    // =========================================================
    const isCommonValid =
      title?.trim() &&
      Number(totalQuestions) > 0 &&
      Number(questionDuration) > 0 &&
      about_quiz?.trim() &&
      quiz_terms?.trim();

    if (!isCommonValid) {
      alert("Please fill all required quiz details.");
      return;
    }

    // =========================================================
    // ACADEMIC QUIZ VALIDATION
    // Quiz Type 1 - Live Academic
    // Quiz Type 2 - Practice Academic
    // =========================================================
    if (isAcademicQuiz) {
      if (!subject_id) {
        alert("Please select a subject.");
        return;
      }

      if (!updateQuizForm?.class_ids?.length) {
        alert("Please select at least one class.");
        return;
      }
    }

    // =========================================================
    // THEMATIC QUIZ VALIDATION
    // Quiz Type 3 - Live Thematic
    // Quiz Type 4 - Practice Thematic
    // =========================================================
    if (isThematicQuiz) {
      if (!updateQuizForm?.group_idd?.length) {
        alert("Please select at least one group.");
        return;
      }

      if (!updateQuizForm?.themeId) {
        alert("Please select a theme.");
        return;
      }
    }

    // =========================================================
    // LIVE QUIZ VALIDATION
    // Quiz Type 1 - Live Academic
    // Quiz Type 3 - Live Thematic
    // =========================================================
    if (isLiveQuiz) {
      if (
        !registrationStart ||
        !registrationEnd ||
        !start ||
        !registrationFeeMode
      ) {
        alert(
          "Please fill registration start date, registration end date, quiz start date and registration type.",
        );
        return;
      }

      // Validate allotments
      if (!Array.isArray(state?.allotments) || state.allotments.length === 0) {
        alert("Please add difficulty allotments.");
        return;
      }

      const totalPercentage = state.allotments.reduce(
        (sum, a) => sum + Number(a?.percentage || 0),
        0,
      );

      if (totalPercentage !== 100) {
        alert(
          "Total percentage of difficulty allotments must be exactly 100%.",
        );
        return;
      }

      // =======================================================
      // DATE VALIDATION
      // =======================================================
      const now = Date.now();

      const regStart = Date.parse(registrationStart);
      const regEnd = Date.parse(registrationEnd);
      const startDate = Date.parse(start);

      if (
        Number.isNaN(regStart) ||
        Number.isNaN(regEnd) ||
        Number.isNaN(startDate)
      ) {
        alert("Please provide valid registration and quiz dates.");
        return;
      }

      if (regStart <= now) {
        alert("Registration start date must be in the future.");
        return;
      }

      if (regEnd <= regStart) {
        alert("Registration end date must be after registration start date.");
        return;
      }

      if (startDate <= regEnd) {
        alert("Quiz start date must be after registration end date.");
        return;
      }
    }

    // =========================================================
    // COMMON PAYLOAD
    // =========================================================
    const commonBody = {
      quiz_id: id,
      title: title?.trim(),
      start_date: start,
      total_questions: Number(totalQuestions),
      duration_per_question: Number(questionDuration),
      marks_per_question: Number(correct),
      negative_marks_wrong: Number(wrong),
      negative_marks_skipped: Number(skipped),
      about_quiz,
      quiz_terms,
      quiz_type: quizType,
      school_id: user?.admin_id ?? "",
      user_id: user?.id ?? "",
      // updated_by,
      description,
    };

    // =========================================================
    // ACADEMIC / THEMATIC PAYLOAD
    // =========================================================
    let typeSpecificBody = {};

    // ---------------------------------------------------------
    // Academic
    // Type 1 - Live Academic
    // Type 2 - Practice Academic
    // ---------------------------------------------------------
    if (isAcademicQuiz) {
      typeSpecificBody = {
        subject_id: Number(subject_id),
        class_id: updateQuizForm.class_ids,
      };
    }

    // ---------------------------------------------------------
    // Thematic
    // Type 3 - Live Thematic
    // Type 4 - Practice Thematic
    // ---------------------------------------------------------
    if (isThematicQuiz) {
      typeSpecificBody = {
        group_id: updateQuizForm.group_idd,
        theme_id:
          selectedSubThemes?.length > 0
            ? selectedSubThemes
            : [updateQuizForm.themeId],
      };
    }

    // =========================================================
    // LIVE QUIZ PAYLOAD
    // =========================================================
    let liveBody = {};

    if (isLiveQuiz) {
      liveBody = {
        allotments: state.allotments.filter(
          (a) => Number(a?.percentage || 0) > 0,
        ),

        registration_start_date: registrationStart,

        registration_end_date: registrationEnd,

        registration_fee:
          registrationFeeMode === "free"
            ? 0
            : parseFloat(registrationCost || 0).toFixed(2),

        prizes: prizeDescription,

        registration_type: registrationFeeMode,
      };
    }

    // =========================================================
    // FINAL PAYLOAD
    // =========================================================
    const body = {
      ...commonBody,
      ...typeSpecificBody,
      ...liveBody,
    };

    console.log("====================================");
    console.log("Quiz Type:", quizType);
    console.log("Is Live Quiz:", isLiveQuiz);
    console.log("Is Practice Quiz:", isPracticeQuiz);
    console.log("Is Academic Quiz:", isAcademicQuiz);
    console.log("Is Thematic Quiz:", isThematicQuiz);
    console.log("====================================");
    console.log("🧾 Final Payload before confirmation:", body);

    // =========================================================
    // CONFIRMATION
    // =========================================================
    if (!window.confirm("Are you sure you want to update this quiz?")) {
      console.log("❌ Update cancelled by user");
      return;
    }

    console.log("body", JSON.stringify(body));

    // =========================================================
    // API CALL
    // =========================================================
    try {
      const res = await dispatch(updateQuiz(body));

      console.log("✅ API Response:", res);

      if (res?.payload?.message) {
        alert(res.payload.message);
      } else {
        alert("Quiz updated successfully!");
      }

      // Reset allotments
      setStatee({
        allotments: [],
      });

      // Close popup
      dispatch(
        setState({
          key: "showPopup",
          value: false,
        }),
      );
      await dispatch(
        getQuizzes({
          quizType: quizType,
          schoolId: user?.admin_id ?? "",
        }),
      );
    } catch (err) {
      console.error("❌ Error updating quiz:", err);

      alert("Error updating quiz. Check console for details.");
    }
  };
  // ✅ FIX: same corrected behaviour as CreateQuiz.js's getCount:
  // - payload key is "theme_id" (the API's actual field name) — this was
  //   sending "theme_ids" instead, which the backend would silently ignore.
  // - `silent` lets callers probe whether a combination has questions
  //   without touching the visible table or popping an alert.
  // - `filterToChildThemes` scopes level_counts/total_count to rows that
  //   actually have a child_theme, so a sub-theme + group combo with zero
  //   questions can never be masked by an unrelated parent-only
  //   (child_theme: "") row that happens to have questions.
  const scopeCountData = (data, filterToChildThemes) => {
    if (!data) return data;
    const levelCounts = data.level_counts || [];
    const hasChildRows = levelCounts.some((row) => row.child_theme);
    const scopedRows =
      filterToChildThemes && hasChildRows
        ? levelCounts.filter((row) => row.child_theme)
        : levelCounts;
    const total_count = scopedRows.reduce(
      (sum, row) => sum + Number(row.total || 0),
      0,
    );
    return { ...data, level_counts: scopedRows, total_count };
  };

  const getCount = async ({
    class_ids,
    theme_ids,
    group_id,
    subject_id,
    silent = false,
    filterToChildThemes = false,
  }) => {
    if (!quizType) return null;

    const payload =
      quizType === 1 || quizType === 2
        ? {
            class_id: class_ids,
            subject_id,
          }
        : quizType === 3 || quizType === 4
          ? {
              theme_id: theme_ids,
              group_id,
            }
          : {};
    try {
      const res = await axios.post(
        "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-count",
        {
          ...payload,
          quiz_type: quizType,
        },
      );

      console.log("✅ API Response:", res.data);

      const scopedData = scopeCountData(res.data, filterToChildThemes);

      if (!silent) {
        setCountInfo(scopedData || []);
      }
      return scopedData;
    } catch (err) {
      console.error("❌ getAvailableQuestionsCount error:", err);
      // rejectWithValue can only be used inside createAsyncThunk, so use throw here
      throw err.response?.data || err.message;
    }
  };

  // ✅ NEW: getCount previously existed but was never called anywhere in
  // this file (both call sites were commented out), so the "Available
  // Questions Count" block never rendered while editing a quiz. This keeps
  // the count in sync with whatever is currently selected — theme/sub-theme
  // + group for thematic quizzes, subject + class(es) for academic quizzes
  // — the same way CreateQuiz.js keeps its count in sync as filters change.
  useEffect(() => {
    const isThematicQuiz = quizType === 3 || quizType === 4;
    const isAcademicQuiz = quizType === 1 || quizType === 2;

    if (isThematicQuiz) {
      const groupIds = updateQuizForm?.group_idd || [];
      const hasSubThemesSelected = selectedSubThemes?.length > 0;
      const themeIds = hasSubThemesSelected
        ? selectedSubThemes.map(Number)
        : updateQuizForm?.themeId
          ? [Number(updateQuizForm.themeId)]
          : [];

      if (groupIds.length > 0 && themeIds.length > 0) {
        getCount({
          theme_ids: themeIds,
          group_id: groupIds,
          filterToChildThemes: hasSubThemesSelected,
        });
      } else {
        setCountInfo(null);
      }
    }

    if (isAcademicQuiz) {
      const classIds = updateQuizForm?.class_ids || [];
      if (subject_id && classIds.length > 0) {
        getCount({ class_ids: classIds, subject_id });
      } else {
        setCountInfo(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    quizType,
    JSON.stringify(updateQuizForm?.group_idd),
    JSON.stringify(selectedSubThemes),
    updateQuizForm?.themeId,
    JSON.stringify(updateQuizForm?.class_ids),
    subject_id,
  ]);

  useEffect(() => {
    if (quizType !== 3 && quizType !== 4) return;

    const selectedGroups = Array.isArray(updateQuizForm?.group_idd)
      ? updateQuizForm.group_idd
      : [];
    const hasSubThemesSelected = selectedSubThemes?.length > 0;
    const themeIds = hasSubThemesSelected
      ? selectedSubThemes.map(Number)
      : updateQuizForm?.themeId
        ? [Number(updateQuizForm.themeId)]
        : [];

    if (selectedGroups.length === 0 || themeIds.length === 0) return;

    let cancelled = false;

    const removeUnavailableGroups = async () => {
      try {
        const availability = await Promise.all(
          selectedGroups.map(async (groupId) => {
            const result = await getCount({
              theme_ids: themeIds,
              group_id: [groupId],
              silent: true,
              filterToChildThemes: hasSubThemesSelected,
            });

            return {
              groupId,
              hasQuestions: Number(result?.total_count) > 0,
            };
          }),
        );

        if (cancelled) return;

        const availableGroups = availability
          .filter(({ hasQuestions }) => hasQuestions)
          .map(({ groupId }) => groupId);

        if (availableGroups.length !== selectedGroups.length) {
          dispatch(
            setUpdateQuizForm({
              key: "group_idd",
              value: availableGroups,
            }),
          );
        }
      } catch (err) {
        if (!cancelled) {
          console.error("Error rechecking selected group availability:", err);
        }
      }
    };

    removeUnavailableGroups();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    quizType,
    JSON.stringify(updateQuizForm?.group_idd),
    JSON.stringify(selectedSubThemes),
    updateQuizForm?.themeId,
  ]);

  // ✅ NEW: same validation behaviour as CreateQuiz.js's
  // handleGroupCheckboxToggle — before a group gets checked, silently probe
  // whether it actually has questions for the currently selected
  // theme/sub-theme(s). If it doesn't, block the check and alert instead of
  // letting an empty group get selected.
  const handleGroupCheckboxToggle = async (group, checked) => {
    const gId = group.group_id;
    const currentGroups = updateQuizForm?.group_idd || [];

    if (!checked) {
      dispatch(
        setUpdateQuizForm({
          key: "group_idd",
          value: currentGroups.filter((id) => id !== gId),
        }),
      );
      return;
    }

    const hasSubThemesSelected = selectedSubThemes?.length > 0;
    const themeIdsForProbe = hasSubThemesSelected
      ? selectedSubThemes.map(Number)
      : updateQuizForm?.themeId
        ? [Number(updateQuizForm.themeId)]
        : [];

    if (themeIdsForProbe.length === 0) {
      alert("Please select a theme before choosing a group.");
      return;
    }

    try {
      const probe = await getCount({
        theme_ids: themeIdsForProbe,
        group_id: [gId],
        silent: true,
        filterToChildThemes: hasSubThemesSelected,
      });

      if (!probe || Number(probe.total_count) <= 0) {
        alert(
          `"${group.group_name}" has no questions available for the selected theme. Please choose a different group.`,
        );
        return; // ❌ leave unchecked
      }

      dispatch(
        setUpdateQuizForm({
          key: "group_idd",
          value: [...currentGroups, gId],
        }),
      );
    } catch (err) {
      console.error("Error verifying group question count:", err);
      alert(
        "Could not verify question availability for this group. Please try again.",
      );
    }
  };

  // ✅ NEW: same idea for classes on academic quizzes — before a class gets
  // checked, silently probe whether it has questions for the selected
  // subject.
  const handleClassCheckboxToggle = async (cls, checked) => {
    const classId = cls.class_id;
    const currentIds = Array.isArray(updateQuizForm?.class_ids)
      ? updateQuizForm.class_ids
      : [];

    if (!checked) {
      dispatch(
        setUpdateQuizForm({
          key: "class_ids",
          value: currentIds.filter((id) => id !== classId),
        }),
      );
      return;
    }

    if (!subject_id) {
      alert("Please select a subject before choosing a class.");
      return;
    }

    try {
      const probe = await getCount({
        class_ids: [classId],
        subject_id,
        silent: true,
      });

      if (!probe || Number(probe.total_count) <= 0) {
        alert(
          `"${cls.class_name}" has no questions available for the selected subject. Please choose a different class.`,
        );
        return; // ❌ leave unchecked
      }

      dispatch(
        setUpdateQuizForm({
          key: "class_ids",
          value: [...currentIds, classId],
        }),
      );
    } catch (err) {
      console.error("Error verifying class question count:", err);
      alert(
        "Could not verify question availability for this class. Please try again.",
      );
    }
  };

  const isLive = quizType === 1 || quizType === 3;
  const isAcademic = quizType === 1 || quizType === 2;
  const isThematic = quizType === 3 || quizType === 4;
  const totalAllotment = state.allotments.reduce(
    (sum, a) => sum + Number(a.percentage || 0),
    0,
  );

  return (
    <div className="cq-page cq-edit">
      <div className="cq-shell">
        <div className="cq-shell__head">
          <span className="qv-kicker">
            {quizTypesList?.data?.find((e) => e.id === quizType)?.type}
          </span>
          <h2 className="qv-title">Edit quiz</h2>
        </div>

        {/* ---------- Title ---------- */}
        <section className="cq-section cq-section--full">
          <div className="cq-field">
            <label className="cq-label">Quiz title</label>
            <input
              type="text"
              className="cq-input"
              placeholder="Enter quiz title"
              value={title}
              onChange={(e) => handleChange("title", e.target.value)}
              required
            />
          </div>
        </section>

        {/* ---------- Registration ---------- */}
        {isLive && (
          <section className="cq-section">
            <h3 className="cq-section__title">Registration details</h3>
            <div className="cq-grid">
              {[
                {
                  label: "Registration start",
                  key: "registrationStart",
                  value: registrationStart,
                },
                {
                  label: "Registration end",
                  key: "registrationEnd",
                  value: registrationEnd,
                },
                { label: "Quiz date", key: "start", value: start },
              ].map(({ label, key, value }) => (
                <div className="cq-field" key={key}>
                  <label className="cq-label">{label}</label>
                  <input
                    type="datetime-local"
                    className="cq-input"
                    value={value}
                    onChange={(e) => handleChange(key, e.target.value)}
                    required
                  />
                </div>
              ))}

              <div className="cq-field">
                <span className="cq-label">Registration fee</span>
                <div className="cq-segment">
                  {["free", "paid"].map((mode) => (
                    <label key={mode}>
                      <input
                        type="radio"
                        name="registrationFeeMode"
                        value={mode}
                        checked={registrationFeeMode === mode}
                        onChange={(e) =>
                          handleChange("registrationFeeMode", e.target.value)
                        }
                        required
                      />
                      <span style={{ textTransform: "capitalize" }}>
                        {mode}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              {registrationFeeMode === "paid" && (
                <div className="cq-field">
                  <label className="cq-label">Registration cost</label>
                  <input
                    type="number"
                    className="cq-input"
                    name="registrationCost"
                    value={registrationCost}
                    onChange={(e) =>
                      handleChange("registrationCost", e.target.value)
                    }
                    required
                    min="0"
                  />
                </div>
              )}
            </div>
          </section>
        )}

        {/* ---------- Question details ---------- */}
        <section className="cq-section">
          <h3 className="cq-section__title">Question details</h3>
          <div className="cq-grid">
            {[
              {
                label: "Total questions",
                key: "totalQuestions",
                value: totalQuestions,
              },
              {
                label: "Duration per question (seconds)",
                key: "questionDuration",
                value: questionDuration,
              },
            ].map(({ label, key, value }) => (
              <div className="cq-field" key={key}>
                <label className="cq-label">{label}</label>
                <input
                  type="number"
                  className="cq-input"
                  value={value}
                  min={1}
                  onChange={(e) => handleChange(key, Number(e.target.value))}
                  required
                />
              </div>
            ))}
          </div>

          {countInfo && (
            <div className="cq-availability">
              <div className="cq-availability__head">
                <span>Available questions</span>
                <span className="cq-availability__count">
                  {countInfo?.total_count ?? 0}
                </span>
              </div>
              <div className="cq-table-wrap">
                <LevelTableCommon
                  data={countInfo.level_counts || []}
                  type={quizType}
                />
              </div>
            </div>
          )}
        </section>

        {/* ---------- Marking ---------- */}
        <section className="cq-section">
          <h3 className="cq-section__title">Marking</h3>
          <div className="cq-grid">
            <div className="cq-field">
              <label className="cq-label">Marks for correct answer</label>
              <input
                type="number"
                className="cq-input"
                value={correct}
                min="1"
                onChange={(e) => handleChange("correct", e.target.value)}
                required
              />
            </div>

            {[
              {
                key: "enableWrongMarks",
                checked: enableWrongMarks,
                label: "Negative marking for wrong answer",
                inputKey: "wrong",
                value: wrong,
              },
              {
                key: "enableSkippedMarks",
                checked: enableSkippedMarks,
                label: "Negative marking for skipped answer",
                inputKey: "skipped",
                value: skipped,
              },
            ].map(({ key, checked, label, inputKey, value }) => (
              <div className="cq-field" key={key}>
                <label className="cq-chip" style={{ alignSelf: "flex-start" }}>
                  <input
                    type="checkbox"
                    checked={!!checked}
                    onChange={(e) => handleChange(key, e.target.checked)}
                  />
                  {label}
                </label>
                {checked && (
                  <input
                    type="number"
                    className="cq-input"
                    placeholder={`Marks for ${inputKey} answer`}
                    value={value}
                    max="0"
                    onChange={(e) => handleChange(inputKey, e.target.value)}
                  />
                )}
              </div>
            ))}
          </div>
        </section>

        {/* ---------- Subject + classes ---------- */}
        {isAcademic && (
          <section className="cq-section">
            <h3 className="cq-section__title">Subject and classes</h3>
            <div className="cq-grid">
              <div className="cq-field cq-field--wide">
                <label className="cq-label">Subject</label>
                <select
                  className="cq-select"
                  value={subject_id || ""}
                  onChange={(e) => {
                    const newSubjectId = Number(e.target.value);
                    dispatch(
                      setUpdateQuizForm({ key: "class_ids", value: [] }),
                    );
                    handleChange("subject_id", newSubjectId);
                  }}
                  disabled={!class_id} // disable if no class selected
                >
                  <option value="">Select subject</option>
                  {subjects.map((s) => {
                    const id = s.subject_id ?? s.id;
                    const label =
                      s.subject_name ?? s.name ?? s.title ?? `Subject ${id}`;
                    return (
                      <option key={id} value={id}>
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="cq-field cq-field--wide">
                <span className="cq-label">Classes</span>
                {subjectSpecificClasses?.length === 0 && (
                  <p className="cq-error">
                    No classes found for the selected subject.
                  </p>
                )}
                <div className="cq-chips">
                  {(subjectSpecificClasses?.data || []).map((cls) => (
                    <label key={cls.class_id} className="cq-chip">
                      <input
                        type="checkbox"
                        name="class_ids"
                        value={cls.class_id}
                        checked={
                          Array.isArray(updateQuizForm?.class_ids) &&
                          updateQuizForm.class_ids.includes(cls.class_id)
                        }
                        onChange={(e) => {
                          handleClassCheckboxToggle(cls, e.target.checked);
                        }}
                        disabled={!updateQuizForm?.subject_id}
                      />
                      {cls.class_name}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ---------- Theme + groups ---------- */}
        {isThematic && (
          <section className="cq-section">
            <h3 className="cq-section__title">Theme and group</h3>
            <div className="cq-grid">
              <div className="cq-field cq-field--wide">
                <ThemeSelector
                  themes={themes}
                  themeData={updateQuizForm.themeData}
                />
              </div>
              <div className="cq-field cq-field--wide">
                <span className="cq-label">Groups</span>
                {error && <p className="cq-error">{error}</p>}
                <div className="cq-chips">
                  {groups && groups.length > 0 ? (
                    groups.map((g) => (
                      <label key={g.group_id} className="cq-chip">
                        <input
                          type="checkbox"
                          value={g.group_id}
                          checked={updateQuizForm?.group_idd?.includes(
                            g.group_id,
                          )}
                          onChange={(e) => {
                            handleGroupCheckboxToggle(g, e.target.checked);
                          }}
                        />
                        {g.group_name}
                      </label>
                    ))
                  ) : (
                    <p className="cq-help">No groups available</p>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ---------- Question allotment ---------- */}
        {isLive && (
          <section className="cq-section">
            <h3 className="cq-section__title">Question allotment</h3>
            <p className="cq-section__hint">
              Split the questions across difficulty levels. The total must be
              exactly 100%.
            </p>
            <div className="cq-field" style={{ maxWidth: 260 }}>
              <label className="cq-label">Add difficulty level</label>
              <select
                className="cq-select"
                onChange={(e) => handleAllotmentChange(e.target.value)}
                value=""
              >
                <option value="">Select</option>
                {["basic", "advanced", "ultra", "docmaster"].map((level) => (
                  <option key={level} value={level}>
                    {level}
                  </option>
                ))}
              </select>
            </div>

            <div className="cq-allot" style={{ marginTop: 12 }}>
              {state.allotments.map((each, index) => (
                <div className="cq-allot__item" key={index}>
                  <span className="cq-allot__name">
                    {{
                      easy: "Basic",
                      medium: "Advanced",
                      hard: "Ultra",
                      docmaster: "Docmaster",
                      basic: "Basic",
                      advanced: "Advanced",
                      ultra: "Ultra",
                    }[each.difficulty_level] || each.difficulty_level}
                  </span>
                  <input
                    type="number"
                    placeholder="0"
                    value={each.percentage}
                    onChange={(e) =>
                      updatePercent(index, Number(e.target.value))
                    }
                  />
                  <span>%</span>
                  <button
                    type="button"
                    className="cq-allot__remove"
                    title="Remove"
                    aria-label={`Remove ${each.difficulty_level}`}
                    onClick={() => removeAllotment(each.difficulty_level)}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>

            <div
              className={`cq-total ${
                totalAllotment === 100 ? "is-ok" : "is-bad"
              }`}
            >
              Total {totalAllotment}% (must be 100%)
            </div>
          </section>
        )}

        {/* ---------- Prize ---------- */}
        {isLive && (
          <section className="cq-section">
            <h3 className="cq-section__title">Winner prize details</h3>
            <textarea
              className="cq-textarea"
              placeholder="Describe the prizes for the winners"
              value={prizeDescription}
              onChange={(e) => handleChange("prizeDescription", e.target.value)}
            />
          </section>
        )}

        {/* ---------- About + terms ---------- */}
        <section className="cq-section cq-section--full">
          <h3 className="cq-section__title">About and terms</h3>
          <div className="cq-grid cq-grid--split">
            <div className="cq-field cq-field--wide">
              <label className="cq-label">About quiz</label>
              <textarea
                className="cq-textarea"
                value={about_quiz}
                onChange={(e) => handleChange("about_quiz", e.target.value)}
                required
              />
            </div>

            <div className="cq-field">
              <label className="cq-label">Terms and conditions</label>
              <textarea
                className="cq-textarea cq-textarea--terms"
                value={quiz_terms}
                onChange={(e) => handleChange("quiz_terms", e.target.value)}
                required
              />
            </div>

            <div className="cq-field">
              <span className="cq-label">Preview</span>
              <div className="cq-preview">
                {quizType === 2 && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: formatTerms(quiz_terms),
                    }}
                  />
                )}
                {(quizType === 1 || quizType === 3) && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: convertTermsToHtml(quiz_terms),
                    }}
                  />
                )}
              </div>
            </div>

            <div className="cq-field cq-field--wide">
              <div className="cq-note">
                <strong>Keep these variables in the terms above:</strong>
                <ol>
                  <li>[Number] – total number of questions.</li>
                  <li>
                    [X seconds] – total duration, calculated as total questions
                    × duration per question (in seconds).
                  </li>
                  <li>[X second] – duration for each question (in seconds).</li>
                  <li>[Correct] – score awarded for each correct answer.</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <div className="cq-actions">
          <button
            type="button"
            className="cq-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSubmit();
            }}
          >
            Update quiz
          </button>
        </div>
      </div>
    </div>
  );
}
